export const GLITCHTIP_DSN = process.env.REACT_APP_GLITCHTIP_DSN;
export const GLITCHTIP_ENVIRONMENT = process.env.REACT_APP_NODE_ENV;
export const GLITCHTIP_TRACES_SAMPLE_RATE = 0.01;
